/**
 *机构管理接口实现
 *@author xujinjiang
 *@date 2022/3/3 9:39
 */
import { BaseServiceImpl } from '@/service/BaseServiceImpl';
import { InstitutionUrlConfig } from '@/config/InstitutionUrlConfig';

export class InstitutionServiceImpl extends BaseServiceImpl {
  private static service: InstitutionServiceImpl;

  public static getInstance(): InstitutionServiceImpl {
    if (InstitutionServiceImpl.service == null) {
      InstitutionServiceImpl.service = new InstitutionServiceImpl();
    }

    return InstitutionServiceImpl.service;
  }

  /**
   * 获取机构列表
   */
  getInstitutionList(developerId: string, orgId: string, orgName: string, pageNo: any, pageSize: any): Promise<any> {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    const option = BaseServiceImpl.getGetOption();
    option.url = InstitutionUrlConfig.getInstitutionList;
    option.params = {
      developerId: developerId,
      id: orgId,
      orgName: orgName,
      pageNo: pageNo,
      pageSize: pageSize
    };
    return new Promise((resolve, reject) => {
      self
        .huohuaRequest(option)
        .then(function (res) {
          resolve(res.data);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }

  /**
   * 新增机构
   * @param object
   */
  addInstitution(object: any): Promise<any> {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    const option = BaseServiceImpl.getPostOption();
    option.url = InstitutionUrlConfig.addInstitution;
    option.data = JSON.stringify(object);
    option.headers['Content-Type'] = BaseServiceImpl.jsonContentType;
    return new Promise((resolve, reject) => {
      self
        .huohuaRequest(option)
        .then(function (res) {
          resolve(res.data);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }

  /**
   * 修改机构
   * @param object
   */
  modifyInstitution(object: any) {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    const option = BaseServiceImpl.getPostOption();
    option.url = InstitutionUrlConfig.modifyInstitution;
    option.data = JSON.stringify(object);
    option.headers['Content-Type'] = BaseServiceImpl.jsonContentType;
    return new Promise((resolve, reject) => {
      self
        .huohuaRequest(option)
        .then(function (res) {
          resolve(res.data);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }

  // 获取省信息
  getProvinceInfo(): Promise<any> {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    const option = BaseServiceImpl.getGetOption();
    option.url = InstitutionUrlConfig.getProvinceInfo;
    return new Promise((resolve, reject) => {
      self
        .huohuaRequest(option)
        .then(function (res) {
          resolve(res.data);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }

  // 获取市信息
  getCityInfo(province: string) {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    const option = BaseServiceImpl.getGetOption();
    option.url = InstitutionUrlConfig.getCityInfo;
    option.params = {
      province: province
    };
    return new Promise((resolve, reject) => {
      self
        .huohuaRequest(option)
        .then(function (res) {
          resolve(res.data);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }

  // 获取区信息
  getDistrictInfo(city: string) {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    const option = BaseServiceImpl.getGetOption();
    option.url = InstitutionUrlConfig.getDistrictInfo;
    option.params = {
      city: city
    };
    return new Promise((resolve, reject) => {
      self
        .huohuaRequest(option)
        .then(function (res) {
          resolve(res.data);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }
}
